import {
  Banknote, Brain, Building2, CheckCheck, Mail, ScanLine, Users,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { StapIcoon, Stroom as StroomBlok } from '../lib/types'

/* ===========================================================================
 *  De keten, als plaat
 *
 *  Waarom dit het eerste is wat je ziet
 *  ------------------------------------
 *
 *  Omdat de vraag die iedereen werkelijk heeft niet "hoe werkt het systeem"
 *  is maar "waar is mijn factuur nu, en moet ik iets". Die vraag beantwoord
 *  je met een plaatje waar iemand zijn vinger op kan zetten, niet met drie
 *  bladzijden waarin de stappen ergens staan.
 *
 *  Waarom er bij elke stap staat WIE hem doet
 *  ------------------------------------------
 *
 *  Dat is de helft van de uitleg. Zonder dat onderscheid wordt een stap die
 *  vanzelf gaat een stap waar iemand op zit te wachten -- en een stap die op
 *  een mens wacht, een stap waarvan iedereen denkt dat de computer hem wel
 *  doet. Precies daar blijven stapels liggen.
 *
 *  Vandaar twee merkjes en geen kleurtje: COMPUTER of JIJ, voluit. Een kleur
 *  moet je onthouden; een woord lees je.
 * =========================================================================== */

const ICONEN: Record<StapIcoon, LucideIcon> = {
  mail: Mail,
  ogen: ScanLine,
  brein: Brain,
  vink: CheckCheck,
  twee: Users,
  kluis: Building2,
  bank: Banknote,
}

export default function Stroom({ blok }: { blok: StroomBlok }) {
  return (
    <div className="stroom">
      {blok.titel && <h3 className="stroom-titel">{blok.titel}</h3>}

      <ol className="stroom-lijst">
        {blok.stappen.map((stap, i) => {
          const Icoon = ICONEN[stap.icoon] ?? CheckCheck
          return (
            <li key={stap.naam} className={`stroom-stap ${stap.wie}`}>
              <span className="nummer">{i + 1}</span>

              <span className="vlag"><Icoon size={20} /></span>

              <span className="tekst">
                <span className="naam">{stap.naam}</span>
                <span className="wat">{stap.wat}</span>
              </span>

              <span className={`doener ${stap.wie}`}>
                {stap.wie === 'machine' ? 'computer' : 'jij'}
              </span>
            </li>
          )
        })}
      </ol>
    </div>
  )
}
